import React, { useState } from "react";
import {
  AppBar,
  Button,
  Container,
  makeStyles,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { Formik } from "formik";
import * as yup from "yup";
import Page from "src/components/Page";
import { useSnackbar } from "notistack";
import ParkService from "./ParkService";
import ComplexModal from "./components/ComplexModal";
import PayModal from "./components/PayModal";

const useStyles = makeStyles((theme) => ({
  plateContainer: {
    display: "flex",
    flexDirection: "column",
  },
  plateTitle: {
    border: "1px black dotted",
    color: "black",
    fontWeight: "bolder",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    backgroundColor: "orange",
    textAlign: "center",
    fontSize: "1.5em",
    padding: 10,
  },
  input: {
    border: "1px black dotted",
    borderTop: "none",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    height: 120,
    padding: 10,
    fontSize: "4em",
    textAlign: "center",
  },
  base: {
    textAlign: "center",
    "&:hover": {
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
    },
    "&$focused": {
      borderColor: theme.palette.primary.main,
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
    },
  },
  focused: {},
}));

export const ParkPay = () => {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [conjunto, setConjunto] = useState({});
  const [dataInfo, setDataInfo] = useState(null);
  const [payLink, setPayLink] = useState("");
  const [correo, setCorreo] = useState("");

  return (
    <Page title="Pago de Parqueadero" className="pb-3">
      <Container fixed>
        <AppBar>
          <Toolbar className="justify-content-center">
            <Typography align="center" variant="h3">
              Consulta - Tarifa de Parqueo
            </Typography>
          </Toolbar>
        </AppBar>
        <Toolbar />
        <ComplexModal complex={conjunto} setComplex={setConjunto} />
        {!conjunto.id && (
          <Typography align="center" variant="h4">
            Selecciona un Punto de Parqueaderos
          </Typography>
        )}
        {conjunto.id && !dataInfo ? (
          <div>
            <Formik
              initialValues={{
                plate: "",
              }}
              validationSchema={yup.object().shape({
                plate: yup.string().min(6).max(7).required(),
              })}
              onSubmit={async (values, helpers) => {
                try {
                  helpers.setSubmitting(true);
                  const data = await ParkService.getParking({
                    value: values.plate.replace(/-/g, "").toUpperCase(),
                    conjunto: conjunto.id,
                  });
                  setDataInfo(data);
                  enqueueSnackbar("Datos encontrados con éxito", {
                    variant: "success",
                  });
                } catch (error) {
                  enqueueSnackbar("No se encontró la placa", {
                    variant: "error",
                  });
                } finally {
                  helpers.setSubmitting(false);
                }
              }}
            >
              {({
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className={classes.plateContainer}>
                      <div className={classes.plateTitle}>ECUADOR</div>
                      <TextField
                        InputProps={{
                          classes: {
                            root: classes.base,
                            focused: classes.focused,
                            input: classes.input,
                          },
                          disableUnderline: true,
                        }}
                        name="plate"
                        variant="standard"
                        value={values.plate.toUpperCase()}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.plate && errors.plate}
                        helperText={touched.plate && errors.plate}
                      />
                    </div>
                    <div className="mt-2">
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={isSubmitting}
                      >
                        consultar
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        ) : null}
        {dataInfo ? (
          <div>
            <Typography gutterBottom variant="h3" className="fw-bolder">
              Datos de Pago
            </Typography>
            <Typography gutterBottom variant="h4">
              {`Total a Pagar $${Number(
                dataInfo.value0 + dataInfo.value12
              ).toFixed(2)}`}
            </Typography>
            <Formik
              initialValues={{
                name: "",
                lastname: "",
                email: "",
              }}
              validationSchema={yup.object().shape({
                name: yup.string().required(),
                lastname: yup.string().required(),
                email: yup.string().email().required(),
              })}
              onSubmit={async (values, helpers) => {
                try {
                  helpers.setSubmitting(true);
                  const link = await ParkService.getPayUrl({
                    conjunto: conjunto.id,
                    value0: dataInfo.value0,
                    value12: dataInfo.value12,
                    nombre: values.name,
                    apellido: values.lastname,
                    correo: values.email,
                    descripcion: "pago de parqueadero",
                  });
                  setCorreo(values.email);
                  setPayLink(link);
                } catch (error) {
                  enqueueSnackbar("Error al obtener el link de pago", {
                    variant: "error",
                  });
                } finally {
                  helpers.setSubmitting(false);
                }
              }}
            >
              {({
                values,
                touched,
                errors,
                isSubmitting,
                handleBlur,
                handleChange,
                handleSubmit,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  className="d-flex m-auto justify-content-center flex-column p-3"
                >
                  <TextField
                    name="name"
                    label="Nombre"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                    margin="dense"
                  />
                  <TextField
                    name="lastname"
                    label="Apellido"
                    value={values.lastname}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.lastname && Boolean(errors.lastname)}
                    helperText={touched.lastname && errors.lastname}
                    margin="dense"
                  />
                  <TextField
                    name="email"
                    label="Correo"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    margin="dense"
                  />
                  <Button
                    variant="contained"
                    type="submit"
                    className="mt-2"
                    disabled={isSubmitting}
                  >
                    Generar link de pago
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => setDataInfo(null)}
                    className="mt-2"
                    disabled={isSubmitting}
                  >
                    Consultar otra placa
                  </Button>
                </form>
              )}
            </Formik>
          </div>
        ) : null}
        {payLink && (
          <a href={payLink} target="_blank" rel="noreferrer">
            link
          </a>
        )}
        {payLink ? (
          <PayModal
            open={Boolean(payLink)}
            link={payLink}
            onClose={() => {
              setPayLink("");
              setDataInfo(null);
            }}
            form={{ ...dataInfo, correo }}
          />
        ) : null}
      </Container>
    </Page>
  );
};
